import * as yup from 'yup'

export const createCustomerValidator = yup.object({
  name: yup.string().trim().required('Customer name is required'),
  // Required here because the backend's PartnerDTO marks `logo` @IsNotEmpty: a create without
  // one is rejected with an opaque 400, so the form has to say so before the request. The
  // customer card can still replace the logo later. Relax this only once that constraint goes.
  logo: yup.mixed<File>().nullable().required('Logo is required'),
})
